import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsFacet, ConvertedComponentData, TextInput } from '../../../types'
import { CmsConverterService, defaultFSFacet, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ProductFinderAnswerTileConverter extends CmsConverterService<ProductFinderAnswerTileData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_alt_text?.value
    const title = formData.st_title_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      headline: formData.st_headline ?? defaultTextInput,
      facet: formData.pt_tag[0] ?? defaultFSFacet,
      image: CmsConverterService.mapImage(formData?.st_image, lazyLoad, altText, title).xl
    }
  }
}

export const PRODUCT_FINDER_ANSWER_TILE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ProductFinderAnswerTileData>>('ProductFinderAnswerTileConverter')

export interface ProductFinderAnswerTileData extends ConvertedComponentData {
  headline: TextInput
  facet: CmsFacet
  image: string
}
